export const socialData = [
  {
    id: 1,
    url: "https://github.com/michaelvautour",
    img: "github.svg",
    logoAlt: "Github Logo",
  },

  {
    id: 2,
    url: "https://twitter.com/mikevautourdev",
    img: "Twitter_Social_Icon_Circle_Color.svg",
    logoAlt: "Twitter Logo",
  },

  {
    id: 3,
    url: "https://ca.linkedin.com/in/michael-vautour-26832871",
    img: "linkedin.svg",
    logoAlt: "LinkedIn Logo",
  },

  {
    id: 4,
    url: "mailto:michael.e.vautour@gmail.com?subject=e-Mail%20from%20portfolio%20site",
    img: "email.png",
    logoAlt: "Email Logo",
  },
];
